import React from "react";
import "./styles.scss";
import { addComment } from "../../../../api/comments";
import CommentsList from "./CommentsList";
import NewComment from "./NewComment";

interface Props {
  object: any;
  actions: any;
}

export default (props: Props) => {
  const onSubmitComment = async (comment_params: any) => {
    try {
      let {
        data: { comment },
      } = await addComment(props.object.type, props.object.id, comment_params);

      props.actions.onAddComment(props.object.id, comment);
    } catch (error) {
      console.log(error.message);

      // Remember comments to localStorage if user is not logged in yet.
      if (error.response?.status === 401) {
        localStorage.setItem('comments_before_login', JSON.stringify({type: props.object.type, id: props.object.id, params: comment_params}));
      }
    }
  };
  return (
    <div className="comments m-4">
      <CommentsList comments={props.object.comments} />
      <NewComment onSubmitComment={onSubmitComment} />
    </div>
  );
};
